import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { Actions, Types } from '../reducers/Reasons';
import { getBanishmentReasons, getActRemovalReasons, getReviewRemovalReasons } from 'services/requests/reasons';
import { Alert } from 'helpers/Alert';

function* getBanishmentReasonsData() {
  try {
    const response = yield call(getBanishmentReasons);
    yield put(Actions.getBanishmentReasonsSuccess(response.data));
  } catch (error) {
    console.error('[getBanishmentReasons] failed', {
      status: error?.response?.status,
      data: error?.response?.data,
      message: error?.message,
    });
    yield put(Actions.getBanishmentReasonsFailed(error.message));
    Alert({
      type: 'error',
      title: 'Error',
      text: 'Could not load banishment reasons. Please try again.',
    });
  }
}

export function* WatchGetBanishmentReasons() {
  yield takeEvery(Types.GET_BANISHMENT_REASONS, getBanishmentReasonsData);
}

function* getActRemovalReasonsData() {
  try {
    const response = yield call(getActRemovalReasons);
    yield put(Actions.getActRemovalReasonsSuccess(response.data));
  } catch (error) {
    console.error('[getActRemovalReasons] failed', {
      status: error?.response?.status,
      data: error?.response?.data,
      message: error?.message,
    });
    yield put(Actions.getActRemovalReasonsFailed(error.message));
    Alert({
      type: 'error',
      title: 'Error',
      text: 'Could not load act removal reasons. Please try again.',
    });
  }
}

export function* WatchGetActRemovalReasons() {
  yield takeEvery(Types.GET_ACT_REMOVAL_REASONS, getActRemovalReasonsData);
}

function* getReviewRemovalReasonsData() {
  try {
    const response = yield call(getReviewRemovalReasons);
    yield put(Actions.getReviewRemovalReasonsSuccess(response.data));
  } catch (error) {
    console.error('[getReviewRemovalReasons] failed', {
      status: error?.response?.status,
      data: error?.response?.data,
      message: error?.message,
    });
    yield put(Actions.getReviewRemovalReasonsFailed(error.message));
    Alert({
      type: 'error',
      title: 'Error',
      text: 'Could not load review removal reasons. Please try again.',
    });
  }
}

export function* WatchGetReviewRemovalReasons() {
  yield takeEvery(Types.GET_REVIEW_REMOVAL_REASONS, getReviewRemovalReasonsData);
}

export default function* reasonsSaga() {
  yield all([fork(WatchGetBanishmentReasons), fork(WatchGetActRemovalReasons), fork(WatchGetReviewRemovalReasons)]);
}
